import { Separator } from '@nesso/ui/primitives/separator';

import { PageTitle } from '@/shared/ui/text/page-title';
import { SettingsColumn } from '@/widgets/settings/settings-column';

import { TelehealthLinkRow } from './telehealth-page/telehealth-link-row';

export function TelehealthPage() {
    return (
        <SettingsColumn className="space-y-8">
            <PageTitle>Telehealth</PageTitle>

            <div>
                {/* Figma draws its divider at zero height, in the pixel row above its layout
                    position, so the line's own pixel comes out of the margin above it, not below. */}
                <Separator className="-mt-px mb-4" />
                <TelehealthLinkRow />
            </div>
        </SettingsColumn>
    );
}
